import { CompleteProfileService } from './../../services/account/complete-profile.service';
import { Component, OnInit } from '@angular/core';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { CheckboxModule } from 'primeng/checkbox';
import { MyInstitutesSelectors } from '../../states/myInstitutes/my-institute-selector';
import { Institute } from '../../models/institute/randomInstituteResponse';
import { Store } from '@ngxs/store';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { CommonModule } from '@angular/common';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { Course } from '../../models/enums/enums';
import { MessagesModule } from 'primeng/messages';
import { Router, RouterLink } from '@angular/router';
import { InstituteService } from '../../services/institute/institute.service';
import { InstituteCheckListDTO } from '../../models/institute/checkList/instituteCheckListDto';
import { StudentInstituteCheckListDTO } from '../../models/account/checkList/studentInstituteCheckListDTO';
import { StudentCheckListService } from '../../services/account/student-check-list.service';
import { TooltipModule } from 'primeng/tooltip';
import { RemoveMyInstitute, UpdateMyInstitutesList } from '../../states/myInstitutes/my-institute-actions';
import { UserSelectors } from '../../states/user/user-selector';
import { UserStateModel } from '../../states/user/user-state-model';
import { catchError, filter, forkJoin, iif, map, of, switchMap, take, tap } from 'rxjs';
import { DemoGraphyResponse } from '../../models/account/demographyResponse';
import { AdditionalInformationComponent } from "../additional-information/additional-information.component";
import { AdditionalInformation } from '../../models/enums/additionalInformation';
import { MyInstituteService } from '../../services/institute/myinstitute/my-institute.service';
import { CourseLevelEnum, CourseLevelEnumDescriptions, getCourseLevelEnumFromDescription } from '../../models/enums/courseLevelEnum';
import { InstituteCoursesV2Response } from '../../models/institute/instituteCoursesV2Response';
import { DialogModule } from 'primeng/dialog';
import { FormsModule } from '@angular/forms';
import { MyInstituteRequest } from '../../models/institute/myInstituteRequest';
import { MentorService } from '../../services/account/mentor.service';
import { MentorType } from '../../models/enums/enums';
import { StudentMentorRequestStatus } from '../../models/enums/studentMentorRequestStatus';
import { CalendarModule } from 'primeng/calendar';


enum selectedTab {
  checkList,
  additionalInfo
}

@Component({
  selector: 'app-checklist',
  standalone: true,
  imports: [AutoCompleteModule, ReactiveFormsModule, CommonModule, ProgressSpinnerModule, MessagesModule, TooltipModule,
    InputTextareaModule, ButtonModule, DropdownModule, InputTextModule, CheckboxModule, RouterLink,
    AdditionalInformationComponent, DialogModule, FormsModule, CalendarModule],
  templateUrl: './checklist.component.html',
  styleUrl: './checklist.component.scss'
})
export class ChecklistComponent implements OnInit {

  user!: UserStateModel;
  myInstitutes: Institute[] = [];
  isLoading = true;
  applyingForLevel!: CourseLevelEnum;
  applyingForCourseName: string = '';
  selectedInstitute: Institute | null = null;
  instituteCheckList?: InstituteCheckListDTO;
  studentInstituteCheckList?: StudentInstituteCheckListDTO;
  submitted: boolean = false;
  isSaving: boolean = false;
  Course = Course;
  daysLeft!: number | null;
  mentorDaysLeft: number | null = null;
  hasApprovedMentor: boolean = false;
  displayDeadlineDialog: boolean = false;
  selectedDeadline: Date | null = null;
  isSavingDeadline: boolean = false;
  today: Date = new Date();

  displayCourseDialog: boolean = false;
  courses: InstituteCoursesV2Response[] = [];
  selectedCourse: InstituteCoursesV2Response | undefined;
  loadingCourses: boolean = false;
  savedMyInstituteId: number = 0;

  selectedIntakeYear: string | undefined;
  selectedCourseLevel: number | undefined;
  intakeYears: { label: string, value: string }[] = [];
  courseLevelOptions: { label: string, value: number }[] = [];

  additionalInfoType = AdditionalInformation;
  selectedTab = selectedTab;
  currentSelectedTab = selectedTab.checkList;

  checklistForm: FormGroup = this.formBuilder.group({
    essayPilot: [null],
    lORs: [null],
    personalDocuments: [null],
    testScores: [null],
    financialAids: [null],
    applicationForms: [null],
  });

  constructor(
    private store: Store,
    private formBuilder: FormBuilder,
    private messageService: MessageService,
    private completeProfileService: CompleteProfileService,
    private router: Router,
    private studentCheckListService: StudentCheckListService,
    private instituteService: InstituteService,
    private myInstituteService: MyInstituteService,
    private mentorService: MentorService,
  ) { }

  ngOnInit(): void {
    this.getCheckList();
  }

  openAdditionalInfo() {
    this.currentSelectedTab = selectedTab.additionalInfo;
  }
  // getCheckList() {
  //   this.store.select(UserSelectors.getUser).pipe(
  //     filter(user => !!user?.id), // Ensure the user exists
  //     tap(user => (this.user = user)), // Store the user
  //     switchMap(user => this.completeProfileService.getDemography(user.id).pipe(
  //       map(demography => ({ user, demography })) // Pass user & demography forward
  //     )),
  //     switchMap(({ user, demography }) => this.store.select(MyInstitutesSelectors.getMyInstitute).pipe(
  //       take(1), // Take only the latest value
  //       map(institutes => ({ demography, institutes })) // Pass demography & institutes forward
  //     ))
  //   ).subscribe({
  //     next: ({ demography, institutes }) => {
  //       this.applyingFor = this.mapDegreePreference(demography?.degreePreference);
  //       this.myInstitutes = institutes?.items || [];

  //       if (this.myInstitutes.length > 0) {
  //         this.selectedInstitute = this.myInstitutes[0];
  //         this.calculateDaysLeft(this.myInstitutes[0].appnDeadlineRegular);
  //         this.loadInstituteCheckList(this.selectedInstitute);
  //       }

  //       this.isLoading = false;
  //     },
  //     error: (error) => {
  //       this.isLoading = false;
  //       console.warn('Error while retrieving checklist:', error);
  //     }
  //   });
  // }

  onEditInstitute(institute: Institute | null) {
    if (!institute?.id) return;

    this.selectedInstitute = institute;
    this.displayCourseDialog = true;
    this.loadingCourses = true;
    this.selectedCourse = undefined;
    this.courses = [];
    this.savedMyInstituteId = institute.myInstituteId ?? 0;
    this.intakeYears = this.generateIntakeYears();
    this.courseLevelOptions = this.generateCourseLevels();

    const rawYear = institute.inTakeYear ?? null;
    this.selectedIntakeYear = rawYear ? String(rawYear) : undefined;
    this.selectedCourseLevel = (institute.courseLevel !== null && institute.courseLevel !== undefined)
      ? Number(institute.courseLevel)
      : undefined;

    const savedCourseId = institute.courseId ?? null;

    this.instituteService.listInstituteCoursesEndpoint({
      instituteId: institute.id,
      searchText: '',
      courseLevel: ''
    }).subscribe({
      next: (response) => {
        this.courses = response?.result ?? [];
        this.loadingCourses = false;

        if (savedCourseId && this.courses.length > 0) {
          this.selectedCourse = this.courses.find(c => Number(c.id) === Number(savedCourseId));
          if (this.selectedCourse && (this.selectedCourseLevel === null || this.selectedCourseLevel === undefined)) {
            this.selectedCourseLevel = getCourseLevelEnumFromDescription(this.selectedCourse.courseLevel as string);
          }
        }
      },
      error: () => {
        this.loadingCourses = false;
      }
    });
  }

  confirmCourseUpdate() {
    if (!this.selectedCourse || !this.selectedInstitute?.id) return;

    this.displayCourseDialog = false;
    this.isSaving = true;

    const updatedCourse = this.selectedCourse;
    const updatedCourseLevel = this.selectedCourseLevel;
    const updatedIntakeYear = this.selectedIntakeYear;
    const instituteId = this.selectedInstitute.id;

    const request: MyInstituteRequest = {
      id: this.savedMyInstituteId,
      studentId: this.user.id,
      isAddedByMentor: false,
      instituteId: instituteId,
      courseId: updatedCourse.id,
      inTakeYear: updatedIntakeYear,
      courseLevel: updatedCourseLevel
    };

    this.myInstituteService.updateMyInstitute(request, this.savedMyInstituteId).subscribe({
      next: () => {
        this.isSaving = false;

        const idx = this.myInstitutes.findIndex(i => i.id === instituteId);
        if (idx !== -1) {
          this.myInstitutes[idx] = {
            ...this.myInstitutes[idx],
            courseId: updatedCourse.id,
            myInstituteId: this.savedMyInstituteId,
            inTakeYear: updatedIntakeYear,
            courseLevel: updatedCourseLevel,
            courseName: updatedCourse.courseName
          };

          this.selectedInstitute = { ...this.myInstitutes[idx] };

          this.store.dispatch(new UpdateMyInstitutesList(this.myInstitutes[idx]));
        }

        if (this.studentInstituteCheckList) {
          this.studentInstituteCheckList = {
            ...this.studentInstituteCheckList,
            courseName: updatedCourse.courseName ?? ''
          };
        }

        this.applyingForCourseName = updatedCourse.courseName ?? '';

        this.messageService.add({ severity: 'success', summary: 'Updated', detail: 'Course selection updated!' });

        this.loadInstituteCheckList(this.selectedInstitute!);

        this.selectedCourse = undefined;
      },
      error: () => {
        this.isSaving = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to update course selection.' });
      }
    });
  }

  private generateIntakeYears(): { label: string, value: string }[] {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;
    const maxYear = currentYear + 4;
    const years: { label: string, value: string }[] = [];

    for (let year = currentYear; year <= maxYear; year++) {
      const springDeadlinePassed = (currentYear > year - 1) ||
        (currentYear === year - 1 && currentMonth > 10);
      if (!springDeadlinePassed) {
        years.push({ label: `Spring ${year}`, value: `Spring ${year}` });
      }
      const fallDeadlinePassed = (currentYear > year) ||
        (currentYear === year && currentMonth > 3);
      if (!fallDeadlinePassed) {
        years.push({ label: `Fall ${year}`, value: `Fall ${year}` });
      }
    }
    return years;
  }
  private generateCourseLevels() {
    return Object.keys(CourseLevelEnumDescriptions)
      .filter(key => !isNaN(Number(key)))
      .map(key => ({
        label: CourseLevelEnumDescriptions[Number(key) as CourseLevelEnum],
        value: Number(key)
      }));
  }

  getCourseLevelLabel(level: number | string | null | undefined): string | null {
    if (level === null || level === undefined || level === '') return null;
    const numLevel = Number(level);
    return CourseLevelEnumDescriptions[numLevel as CourseLevelEnum] || null;
  }

  get filteredCourses(): InstituteCoursesV2Response[] {
    if (this.selectedCourseLevel === undefined || this.selectedCourseLevel === null) {
      return this.courses;
    }
    const description = CourseLevelEnumDescriptions[this.selectedCourseLevel as CourseLevelEnum];
    return this.courses.filter(course => (course.courseLevel ?? '').trim() === description);
  }

  onCourseLevelChange() {
    this.selectedCourse = undefined;
  }

  onCourseSelectionChange() {
    if (this.selectedCourse && (this.selectedCourseLevel === null || this.selectedCourseLevel === undefined)) {
      this.selectedCourseLevel = getCourseLevelEnumFromDescription(this.selectedCourse.courseLevel as string);
    }
  }

  cancelCourseDialog() {
    this.displayCourseDialog = false;
    this.selectedCourse = undefined;
    this.selectedCourseLevel = undefined;
  }

  getCheckList() {
    this.store.select(UserSelectors.getUser).pipe(
      filter(user => !!user?.id),
      tap(user => (this.user = user)),
      switchMap(user =>
        forkJoin({
          demography: this.completeProfileService.getDemography(user.id).pipe(catchError(() => of(null))),
          studentMentors: this.mentorService.getStudentMentors(MentorType.Mentor).pipe(catchError(() => of({ result: [] } as any)))
        }).pipe(
          map(({ demography, studentMentors }) => {
            this.hasApprovedMentor = (studentMentors?.result ?? []).some((sm: any) => sm.status === StudentMentorRequestStatus.Approved);
            return { user, demography: demography as DemoGraphyResponse | null };
          })
        )
      ),
      switchMap(({ user, demography }) =>
        this.store.select(MyInstitutesSelectors.getMyInstitute).pipe(
          take(1),
          switchMap(institutes =>
            iif(
              () => institutes?.items?.length > 0,
              of({
                demography,
                institutes: {
                  ...institutes,
                  items: institutes.items.map((item: any) => ({
                    ...item,
                    inTakeYear: item.inTakeYear ?? null,
                    courseLevel: item.courseLevel != null ? Number(item.courseLevel) : null,
                  }))
                }
              }),
              this.myInstituteService.getMyInstitutes().pipe(
                map((response: any) => {
                  const items = response.result?.items || response.result || response;
                  return items.map((item: any) => ({
                    ...item,
                    inTakeYear: item.inTakeYear ?? null,
                    courseLevel: item.courseLevel != null ? Number(item.courseLevel) : null,
                    myInstituteId: item.myInstituteId ?? null,
                    courseId: item.courseId ?? null,
                  }));
                }),
                tap((apiInstitutes: Institute[]) => {
                  this.myInstitutes = apiInstitutes;
                }),
                map(apiInstitutes => ({
                  demography,
                  institutes: { items: apiInstitutes }
                }))
              )
            )
          )
        )
      )
    ).subscribe({
      next: ({ demography, institutes }) => {
        this.applyingForLevel = demography?.degreePreference ?? CourseLevelEnum.BachelorsDegree;
        this.applyingForCourseName = demography?.intendedMajor ?? '';
        this.myInstitutes = institutes?.items || [];

        if (this.myInstitutes.length > 0) {
          this.selectedInstitute = this.myInstitutes[0];
          this.savedMyInstituteId = this.selectedInstitute.myInstituteId ?? 0;
          this.calculateDaysLeft(this.selectedInstitute.applicationDeadlineRegularDecision || '');
          this.loadInstituteCheckList(this.selectedInstitute);
        }

        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }

  loadInstituteCheckList(institute: Institute): void {
    this.currentSelectedTab = selectedTab.checkList;
    this.isLoading = true;
    this.calculateDaysLeft(institute.applicationDeadlineRegularDecision || '');
    this.calculateMentorDaysLeft(institute.mentorDeadline);
    this.selectedInstitute = institute;
    this.savedMyInstituteId = institute.myInstituteId ?? 0;

    if (institute.courseId && !institute.courseName) {
      this.instituteService.listInstituteCoursesEndpoint({
        instituteId: institute.id,
        searchText: '',
        courseLevel: ''
      }).subscribe({
        next: (res) => {
          const courses = res?.result ?? [];
          const found = courses.find((c: any) => Number(c.id) === Number(institute.courseId));
          if (found && this.selectedInstitute && this.selectedInstitute.id === institute.id) {
            this.selectedInstitute.courseName = found.courseName;
            const idx = this.myInstitutes.findIndex(i => i.id === institute.id);
            if (idx !== -1) {
              this.myInstitutes[idx] = { ...this.myInstitutes[idx], courseName: found.courseName };
            }
          }
        }
      });
    }

    this.instituteService.getCheckList({
      instituteId: institute.id,
      courseLevel: this.applyingForLevel,
      courseName: this.applyingForCourseName
    }).subscribe({
      next: (result) => {
        this.isLoading = false;
        this.instituteCheckList = result;
        this.loadStudentInstituteCheckList();
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }

  private calculateDaysLeft(deadline: string) {
    if (!deadline) {
      this.daysLeft = null;
      return;
    }
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    let targetDate = new Date(deadline);
    
    if (isNaN(targetDate.getTime()) || targetDate.getUTCFullYear() < 2000) {
      const currentYear = today.getFullYear();
      targetDate = new Date(`${deadline}, ${currentYear}`);
    }

    if (isNaN(targetDate.getTime())) {
      this.daysLeft = null;
      return;
    }
    
    targetDate.setHours(0, 0, 0, 0);
    const timeDiff = targetDate.getTime() - today.getTime();
    this.daysLeft = Math.max(0, Math.ceil(timeDiff / (1000 * 60 * 60 * 24)));
  }

  private calculateMentorDaysLeft(mentorDeadline?: string | null) {
    if (!mentorDeadline) {
      this.mentorDaysLeft = null;
      return;
    }
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const target = new Date(mentorDeadline);
    if (isNaN(target.getTime())) {
      this.mentorDaysLeft = null;
      return;
    }
    target.setHours(0, 0, 0, 0);
    const timeDiff = target.getTime() - today.getTime();
    this.mentorDaysLeft = Math.max(0, Math.ceil(timeDiff / (1000 * 60 * 60 * 24)));
  }

  private loadStudentInstituteCheckList(): void {
    if (!this.selectedInstitute) return;

    this.studentCheckListService.getStudentCheckList({
      instituteId: this.selectedInstitute?.id ?? '',
      courseLevel: this.applyingForLevel,
      courseName: this.applyingForCourseName
    }, this.user?.id).subscribe({
      next: (response) => {
        this.studentInstituteCheckList = response;
        this.initializeChecklistForm();
      },
      error: () => { }
    });
  }

  private initializeChecklistForm(): void {
    if (!this.studentInstituteCheckList) return;

    this.checklistForm = this.formBuilder.group({
      essayPilot: [this.studentInstituteCheckList.essayPilot, Validators.required],
      lORs: [this.studentInstituteCheckList.lORs, Validators.required],
      personalDocuments: [this.studentInstituteCheckList.personalDocuments, Validators.required],
      testScores: [this.studentInstituteCheckList.testScores, Validators.required],
      financialAids: [this.studentInstituteCheckList.financialAid, Validators.required],
      applicationForms: [this.studentInstituteCheckList.applicationForms, Validators.required],
    });
  }

  saveStudentChecklist(): void {
    this.submitted = true;
    if (this.checklistForm.invalid) {
      this.messageService.add({ severity: 'warn', summary: 'Validation Error', detail: 'Please fill all required fields.' });
      return;
    }

    this.isSaving = true;
    this.studentCheckListService.updateStudentCheckList({
      applicationForms: this.checklistForm.value.applicationForms ?? [],
      courseLevel: this.applyingForLevel,
      courseName: this.applyingForCourseName,
      essayPilot: this.checklistForm.value.essayPilot,
      financialAid: this.checklistForm.value.financialAids,
      instituteId: this.selectedInstitute?.id ?? '',
      lORs: this.checklistForm.value.lORs,
      personalDocuments: this.checklistForm.value.personalDocuments,
      testScores: this.checklistForm.value.testScores
    }, this.user?.id).subscribe({
      next: () => {
        this.isSaving = false;
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Checklist details are updated!' });
      },
      error: () => {
        this.isSaving = false;
      }
    });
  }

  navigateToCompleteProfile(): void {
    this.router.navigate(['portal', 'application-form']);
  }

  toggleMyInstitute() {
    this.store.dispatch(new RemoveMyInstitute({
      instituteId: this.selectedInstitute?.id ?? "",
      studentId: this.user.id
    })).subscribe({
      next: () => {
        this.selectedInstitute = null;
        this.getCheckList();
      },
      error: () => { }
    });
  }

  openDeadlineDialog() {
    if (this.hasApprovedMentor) return;
    this.selectedDeadline = this.selectedInstitute?.mentorDeadline ? new Date(this.selectedInstitute.mentorDeadline) : null;
    this.displayDeadlineDialog = true;
  }

  saveDeadline() {
    if (!this.selectedInstitute?.myInstituteId || this.hasApprovedMentor) return;

    this.isSavingDeadline = true;
    const date = this.selectedDeadline;
    const isoDate = date ? `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}` : null;

    const request: MyInstituteRequest = {
      id: this.selectedInstitute.myInstituteId,
      studentId: this.user.id,
      isAddedByMentor: false,
      instituteId: this.selectedInstitute.id,
      courseId: this.selectedInstitute.courseId ?? 0,
      inTakeYear: this.selectedInstitute.inTakeYear ?? null,
      courseLevel: this.selectedInstitute.courseLevel ?? undefined,
      mentorDeadline: isoDate
    };

    this.myInstituteService.updateMyInstitute(request, this.selectedInstitute.myInstituteId).subscribe({
      next: () => {
        this.isSavingDeadline = false;
        this.displayDeadlineDialog = false;
        if (this.selectedInstitute) {
          this.selectedInstitute.mentorDeadline = isoDate;
          this.calculateMentorDaysLeft(isoDate);
        }
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deadline updated successfully!' });
      },
      error: () => {
        this.isSavingDeadline = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to update deadline.' });
      }
    });
  }
}